import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class FilterLineupsByCorrelationStackCombinations extends Component {
    onCheck(isChecked) {
        const {combo} = this.props;

        this.props.dispatch(Action.do('filterLineupsByCheckedCorrelationStackCombo', {combo, isChecked}));
    }

    isButtonDisabled() {
        const {combo} = this.props;

        return !combo.isUsedInLineup();
    }

    isComboChecked() {
        const {combo, filterLineupsByCorrelationStackCombinations} = this.props;

        return filterLineupsByCorrelationStackCombinations.isComboChecked(combo);
    }

    getClassNames(isComboChecked, isButtonDisabled) {
        const classNames = [];
        classNames.push('search-btn');
        classNames.push(this.props.className || '');

        if (isComboChecked && !isButtonDisabled) {
            classNames.push('active');
        }

        return classNames;
    }

    getTitle(isChecked) {
        return isChecked ? 'Search enabled' : 'Search disabled';
    }

    render() {
        const isComboChecked = this.isComboChecked();
        const isButtonDisabled = this.isButtonDisabled();
        const classNames = this.getClassNames(isComboChecked, isButtonDisabled);
        const title = this.getTitle(isComboChecked);

        return (
            <button
                type="button"
                className={classNames.join(' ')}
                onClick={(() => this.onCheck(!isComboChecked)).bind(this)}
                title={title}
                disabled={isButtonDisabled}
            >
                {title}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {filterLineupsByCorrelationStackCombinations} = state;

    return {
        filterLineupsByCorrelationStackCombinations,
    };
}

export default connect(mapStatesToProps)(FilterLineupsByCorrelationStackCombinations);

export {FilterLineupsByCorrelationStackCombinations};
